// extracted by mini-css-extract-plugin
export var label = "_cu-2";
export var slideContainer = "_cu-0";
export var slider = "_cu-1";